import { render, staticRenderFns } from "./AttachmentTile.vue?vue&type=template&id=0539a691&scoped=true&"
import script from "./AttachmentTile.vue?vue&type=script&lang=js&"
export * from "./AttachmentTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539a691",
  null
  
)

export default component.exports